<div class="AMBenefitOfferModal bg-am-medium-blue text-am-white">
  <div class="AMBenefitOfferModal-header">
    <img src="assets/images/close.svg" alt="close" (click)="onClose()" tabindex="0" role="button" />
  </div>
  <div class="AMBenefitOfferModal-content">
    <img [src]="iconSrc" [alt]="'benefit icon'" class="benefit-icon" />
    <p class="title">{{ settingBenefitTitle('modalbagsredemption.benefitTitle' | translate) }}</p>
    <p class="subtitle" [innerHTML]="benefitSubtitleKey | translate"></p>
    <p class="warning">{{ 'modalbagsredemption.benefitWarning' | translate }}</p>
    <div class="actions">
      <button class="btn-decline" (click)="onClose()">
        {{ 'modalbagsredemption.benefitDecline' | translate }}
      </button>
      <button class="btn-accept" (click)="onRedeem()" [disabled]="submitRedeem">
        <span *ngIf="!submitRedeem">{{ 'modalbagsredemption.benefitAccept' | translate }}</span>
        <div class="btn-accept__spinner" *ngIf="submitRedeem"></div>
      </button>
    </div>
  </div>
</div>
